<template>
<div>
    <div class="order-form-list" v-for="(item,index) in order_form_list">
        <div class="order-number">
            <span>{{language_cut.order_number}}：{{item.orderSn}}</span>
            <span v-if="item.status == 2" style="color: #47C3F0;" @click="generate_credentials(item.orderSn)">{{language_cut.pickup_code}}</span>
            <span v-if="item.status == 1" style="color: #47C3F0;" @click="clickAliPay(item.orderSn)">{{language_cut.pay_btn}}</span>

        </div>
        <div class="list-top" v-for="subItem in item.items">
            <div class="school-img"><img :src="imgUrl + subItem.goods.pic"></div>
            <div class="school-text">
                <div>
                    <span style="color: #403A3A;">{{subItem.title}}</span>
                    <span style="color: #7D7D7D;">{{item.statusName}}</span>
                </div>
                <div>
                    <span style="color: #ADADAF;">领取时间：{{item.collectionTime}}</span>
                    <span style="color: #403A3A;">￥{{subItem.yuan_price}}</span>
                </div>
                <div>
                    <span style="color: #ADADAF;">规格：{{subItem.sku ? subItem.sku.codeName : '无'}}</span>
                    <span style="color: #403A3A;">x{{subItem.count}}</span>
                </div>
            </div>
        </div>
        <div class="list-bottom">
            {{language_cut.order_time}}：{{item.create_time}}
        </div>
    </div>
    <van-overlay :show="show" @click="show = false">
        <div class="wrapper">
            <div class="qrcode-layout">
                <div class="qrcode" id="J-qrcode" ref="qrCodeUrl"></div>
                <!-- <div>取货凭证，请截图保存</div> -->
            </div>
        </div>
    </van-overlay>
</div>
</template>

<script>
import QRCode from 'qrcodejs2'
export default {
    data() {
        return {
            imgUrl: this.$commonVariable.imgUrl,
            order_form_list: [],
            show: false,
            language_cut: {
                order_number: 'order number',      //订单号码
                pickup_code: 'generate pickup code',    // 生成取货码
                pay_btn: 'payment',
                order_time: 'order time',    // 生成取货码
            },
        }
    },
    created(){
        this.order_form_list = JSON.parse(sessionStorage.order)
        this.order_form_list.forEach(item => {
            item.items.forEach(subItem => {
                if (subItem.sku) {
                    subItem.yuan_price = this.pub_fun.centToYuan(subItem.sku.price)
                } else {
                    subItem.yuan_price = this.pub_fun.centToYuan(subItem.price)
                }
                // subItem.yuan_price = this.pub_fun.centToYuan(subItem.price)     // 价格
                item.create_time = subItem.createTime
            })

        })
        this.language_cut_fun()
    },
    methods:{
        clickAliPay(orderSn) {
            if (!this.clickAliPayLoading) {
                this.clickAliPayLoading = true
                this.$service.aliPayPrepare({orderSn : orderSn}).then(res => {
                    this.clickAliPayLoading = false
                    if (res.code === 20000) {
                        window.location.href = res.data
                    } else {
                        this.$notify({ type: 'danger', message: res.msg });
                    }
                }).catch(() => {
                    let msg = sessionStorage.language == 'ch' ? '请求异常' : 'Request exception'
                    this.$notify({ type: 'danger', message: msg });
                })
            }

        },
        language_cut_fun(){     // 语言切换
            if(sessionStorage.language == 'en'){
                this.language_cut = {
                    order_number: 'order number',      //订单号码
                    pickup_code: 'pickup code',    // 生成取货码
                    pay_btn: 'payment',
                    order_time: 'order time',    // 下单时间
                }
            }else{
                this.language_cut = {
                    order_number: '订单号码',      //订单号码
                    pickup_code: '生成取货码',    // 生成取货码
                    pay_btn: '去付款',
                    order_time: '下单时间',    // 下单时间
                }
            }
        },
        generate_credentials(orderNumber){
            let msg = sessionStorage.language == 'ch' ? '取货凭证，请截图保存' : 'Please save the screenshot of the receipt'
            this.$notify({ type: 'success', message: msg, duration: 3000 });
            document.getElementById('J-qrcode').innerHTML = ''
            let qrcode = new QRCode(this.$refs.qrCodeUrl, {
                text: orderNumber, // 需要转换为二维码的内容
                width: 100,
                height: 100,
                colorDark: '#000000',
                colorLight: '#ffffff',
                correctLevel: QRCode.CorrectLevel.H
            })
            console.log(orderNumber);
            this.show = true
        },
    },
}
</script>

<style lang="less" scoped>
    .wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
    }
    .qrcode-layout{
        padding: 0.3rem;
        background-color: #FFF;
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 0.3rem;

        .qrcode{
            display: inline-block;
            // margin-bottom: 0.3rem;

            img {
                width: 132px;
                height: 132px;
                background-color: #fff; //设置白色背景色
                padding: 6px; // 利用padding的特性，挤出白边
                box-sizing: border-box;
            }
        }
    }
    .order-form-list{
        margin-top: 0.2rem;
        width: 100%;
        // height: 2.65rem;
        box-sizing: border-box;
        background-color: #FFF;
        padding: 0.2rem 0.4rem 0 0.4rem;
        font-size: 0.25rem;

        .order-number{
            display: flex;
            justify-content: space-between;
            margin-bottom: 0.2rem;
            color: #403A3A;
        }

        .list-top{
            margin-top: 0.2rem;
            display: flex;
            padding-bottom: 0.2rem;
            border-bottom: 0.01rem solid #E2E2E2;

            .school-img{
                margin-right: 0.3rem;

                img{
                    width: 1.6rem;
                    height: 1.6rem;
                }
            }

            .school-text{
                width: 4.8rem;
                display: flex;
                flex-direction: column;
                justify-content: space-around;

                >div{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }
            }
        }

        .list-bottom{
            height: 0.7rem;
            box-sizing: border-box;
            line-height: 0.7rem;
            display: flex;
            justify-content: flex-end;
            color: #ADADAF;
            font-size: 0.2rem;
        }
    }
</style>
